<form [formGroup]="partnerDetailsForm()" novalidate class="ap-grid-margin-fix">
    <div>
        <ap-checkbox
            [label]="'partner.details.enable.text' | apKeyOverride: contentKeyMap() | apContent"
            formControlName="usePartnerName"
            name="enablePartnerDetails"
            data-testid="use-partner-name-checkbox"
        ></ap-checkbox>
    </div>
    @if (showPartnerFields) {
        <div class="ap-grid ap-grid-cols-1 ap-grid-cols-gt-sm-4 ap-gap-0 ap-gap-gt-sm-5">
            <ap-input
                [label]="'partner.details.partnerInsertion.label' | apKeyOverride: contentKeyMap() | apContent"
                name="partnerInsertion"
                formControlName="partnerInsertion"
                [messages]="partnerInsertionErrorMessages"
                [trim]="true"
                data-testid="partner-insertion"
            >
            </ap-input>
            <ap-input
                [label]="'partner.details.partnerLastName.label' | apKeyOverride: contentKeyMap() | apContent"
                name="partnerLastName"
                [messages]="partnerLastNameErrorMessages"
                (hasDiacritics)="diacriticsChange($event)"
                apDiacriticsNormalizeFormValue
                formControlName="partnerLastName"
                [trim]="true"
                data-testid="partner-last-name"
                class="ap-col-span-gt-sm-3"
            >
            </ap-input>

            <ap-radio-group
                [description]="'partner.details.salutation.title' | apKeyOverride: contentKeyMap() | apContent"
                [control]="partnerDetailsForm().controls['salutation']"
                [messages]="salutationErrorMessages"
                data-testid="salutation"
                class="ap-col-span-gt-sm-4"
            >
                @for (salutation of salutations; track salutation.value) {
                    <ap-radio-button
                        [label]="'partner.details.salutation.' + salutation.key | apKeyOverride: contentKeyMap() | apContent"
                        [value]="salutation.value"
                        name="salutation"
                        formControlName="salutation"
                        [attr.data-testid]="'salutation-' + salutation.value"
                    >
                    </ap-radio-button>
                }
            </ap-radio-group>

            @if (lastNameDiacritic) {
                <ap-notification status="warning" data-bb="diacritic-notification" class="ap-col-span-gt-sm-4">
                    <ap-content
                        [params]="{ partnerName: getLastName() }"
                        key="{{ 'partner.details.diacritics.message' | apKeyOverride: contentKeyMap() }}"
                    ></ap-content>
                </ap-notification>
            }
        </div>
    }
</form>
